import React, { useState, useEffect } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PageTitle } from '../../components/PageTitle';
import { useAuthentication } from '../auth/AuthenticationProvider';

export const ForceChangePassword = () => {
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');

    const { completeNewPassword, challengeUser, challengeUserAttributes } = useAuthentication();
    const navigate = useNavigate();

    useEffect(() => {
        if (!challengeUser) {
            navigate('/');
        }
    }, [challengeUser, navigate]);

    const email = challengeUserAttributes?.email || challengeUser?.getUsername() || '';

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (password !== repeatPassword) {
            toast.error('Podane hasła są różne');
            return;
        }

        try {
            await completeNewPassword(password);
            toast.success('Pomyślnie zmieniono hasło. Zaloguj się ponownie.');
            navigate('/');
        } catch (e: any) {
            if (e.code === 'NotAuthorizedException') {
                toast.error('Sesja wygasła. Zaloguj się ponownie, aby zmienić hasło.');
                navigate('/');
            } else {
                toast.error('Nie udało się zmienić hasła - spróbuj jeszcze raz');
            }
            console.error('Error while changing password', e);
        }
    };

    if (!challengeUser) {
        return null;
    }

    return (
        <Card className="border-0">
            <Card.Body>
                <h6>
                    <Link className="text-decoration-none" to="/">
                        {'<'} Powrót do strony logowania
                    </Link>
                </h6>
                <PageTitle>Wymagana zmiana hasła</PageTitle>
                <p>Twoje hasło wygasło lub zostało zresetowane przez administratora. Musisz ustawić nowe hasło.</p>
                <Form className="w-25" onSubmit={handleSubmit}>
                    <Form.Group className="mb-2">
                        <Form.Label>Email</Form.Label>
                        <Form.Control disabled type="text" value={email} />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Nowe hasło</Form.Label>
                        <Form.Control 
                            autoComplete="new-password" 
                            name="new-password" 
                            type="password" 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)} 
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Powtórz nowe hasło</Form.Label>
                        <Form.Control 
                            autoComplete="confirm-new-password" 
                            name="confirm-new-password" 
                            type="password"
                            value={repeatPassword} 
                            onChange={(e) => setRepeatPassword(e.target.value)} 
                        />
                    </Form.Group>

                    <Button type="submit">Zmień hasło i zaloguj</Button>
                </Form>
            </Card.Body>
        </Card>
    );
};
